var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxMixed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#323237",
    strokeWidth: 2,
    d: "M1 1h18v18H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323237",
    d: "M11 5v10H9V5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxMixed);
export default __webpack_public_path__ + "static/media/checkbox-mixed.78fc90bb7ab80d3af3900d3f5200ba4b.svg";
export { ForwardRef as ReactComponent };